export default {
  title: 'Uusi valikko',
  headers: {
    edit_time: 'Muokkaa aikaa',
  },
  labels: {
    select_all: 'Valitse kaikki',
  },
  fields: {
    name: {
      label: 'Nimi',
      placeholder: 'Anna valikon nimi',
    },
    sorting_order: {
      label: 'Valikon näyttöjärjestys',
      placeholder: 'Anna valikon näyttöjärjestys',
    },
    has_separate_schedule: {
      label: 'Poikkeaa normaaleista aukioloajoista',
    },
    selected_days: {
      label: 'Valitut päivät',
    },
    opening_time: {
      label: 'Avausaika',
    },
    closing_time: {
      label: 'Sulkemisaika',
    },
  },
  buttons: {
    add_opening_time: 'Lisää avausaika',
    add: 'Lisää',
    cancel: 'Peruuta',
    save: 'Tallenna',
    close: 'Sulje',
  },
  feedback: {
    missing_info: 'Puuttuvia tietoja',
  },
  toasts: {
    menu_got_created: 'Valikko luotu',
    menu_got_updated: 'Valikko päivitetty',
  },
};
